import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import React from "react";
import { createConfig, http, WagmiProvider } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { injected, walletConnect } from "wagmi/connectors";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  },
});

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || "";

const metadata = {
  name: "Shaolin soccer",
  description: "Web3 Football customization on TON & ETH",
  url: "https://mint.shaolin.soccer",
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

const chains = [mainnet, sepolia] as const;

const ethRpcUrl =
  process.env.REACT_APP_ETH_RPC_URL || "https://ethereum.publicnode.com";
const sepoliaRpcUrl =
  process.env.REACT_APP_SEPOLIA_RPC_URL || "https://ethereum-sepolia.publicnode.com";

export const wagmiConfig = createConfig({
  chains,
  transports: {
    [mainnet.id]: http(ethRpcUrl),
    [sepolia.id]: http(sepoliaRpcUrl),
  },
  connectors: [
    injected(),
    walletConnect({ projectId, metadata, showQrModal: false }),
  ],
});

createWeb3Modal({
  wagmiConfig,
  projectId,
  themeVariables: {
    "--w3m-z-index": 2000,
    "--w3m-accent": "#4DDA36",
  },
  allWallets: "HIDE",
  enableAnalytics: false,
  enableOnramp: false,
});

interface ProviderProps {
  children: React.ReactNode;
}

export function Web3ModalProvider({ children }: ProviderProps) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
